//import _ from "lodash";
//import { CallService } from "unifiedring-sdk";
import axios from "axios";
import moment from "moment";
import RRule from "rrule";
import store from "../../../context/store/store";
//import { Types } from '../../../context/action/action';
import { UserDetails } from "../../../models/model";
import { config } from "../../constant";
import { getCookie } from "../../utils";

const icsFile = require('ics');

export const getMeetingList = () => {

};

export const getMeetingTemplate = () => {

};

export const deleteMeetingTemplate = () => {

};

export const createScheduleMeeting = () => {

};

export const editScheduleTemplate = () => {

};

export const createInstantMeeting = () => {

};

export const joinMeetingStatus = () => {

};

export const uuidv4 = () => {
  return "xxx-xxx-xxxx".replace(/[xy]/g, function (c) {
    let r = (Math.random() * 8) | 0,
      v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};

export const getMeetingId = () => {
  let data: UserDetails = store.getState().loginReducer.userdetails || [];
  return data.meeting_id || '';
};

export const generatePassword = () => {
  var length = 8,
    charset = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789",
    retVal = "";
  for (var i = 0, n = charset.length; i < length; ++i) {
    retVal += charset.charAt(Math.floor(Math.random() * n));
  }
  return retVal;
};

export const getPersonalData = () => {
  let data: UserDetails = store.getState().loginReducer.userdetails || [];
  let HostDetail = {
    email: data.Email,
    ext: data.ext,
    name: data.caller_id,
    profile_img: data.profile_url,
    roletype: 1,
    sipid: data.sip_login_id,
    user_type: "company"
  };
  return HostDetail;
};

export const calendarType = async (meetingInfo: any, url?: any) => {
  const participantsEmail = await meetingInfo.participants.map((value: any) => value.email).toString();
  let host: any = store.getState().loginReducer.userdetails || [];
  let description: string = meetingInfo.description.split("\n").join(' \n\n');
  let meetingId: string = meetingInfo.is_use_personal_meeting_id ?
    meetingInfo.personal_meeting_id : meetingInfo.meeting_id;
  let password: string = meetingInfo.is_custom_password ? meetingInfo.password : ""
  // let rRule: any;
  // if (meetingInfo.rrule !== '') { rRule = rRRule(meetingInfo.rrule); }

  let calenderInfo = {
    'title': meetingInfo.title,
    'meetingId': meetingId,
    'description': description,
    'participantsEmail': participantsEmail,
    // 'startTime':moment.utc(new Date()).format("YYYYMMDDTHHmmss[Z]"),
    // 'endTime':moment.utc(new Date()).format("YYYYMMDDTHHmmss[Z]"),
    'startTime': moment.utc(new Date(meetingInfo.start_timestamp)).format("YYYYMMDDTHHmmss[Z]"),
    'endTime': moment.utc(new Date(meetingInfo.end_timestamp)).format("YYYYMMDDTHHmmss[Z]"),
    'organizer': { 'name': host?.caller_id, 'email': host?.email },
    'password': meetingInfo.password !== "" ? meetingInfo.password : "",
    'altDescription': host.caller_id + " has Invited you to a meeting! \n\n" +
      "Title : " + meetingInfo.title + ' \n\n' +
      "About Meeting : " + description + ' \n\n' +
      "Join : " + url + ' \n\n' +
      "Meeting-ID : " + meetingInfo.meeting_id + ' \n\n' +
      'Password : ' + password,
    // 'rrule': rRule,
    'participants': meetingInfo.participants

  };

  if (meetingInfo.calender_type === "google") {
    createGoogleLink(calenderInfo);
  } else if (meetingInfo.calender_type === "outlook") {
    createOutlookLink(calenderInfo);
  }
  else if (meetingInfo.calender_type === "iCalendar") {
    icsDownload(calenderInfo);
  }
};


export const createGoogleLink = async (meetingInfo: any) => {
  // eslint-disable-next-line max-len
  const generateURL = encodeURI(`http://www.google.com/calendar/event?action=TEMPLATE&text=${meetingInfo.title}&dates=${meetingInfo.startTime}/${meetingInfo.endTime}&details=${meetingInfo.altDescription}&location=NA&add=${meetingInfo.participantsEmail}&sprop=website:`);
  window.open(generateURL, '_blank');
};

export const createOutlookLink = (meetingInfo: any) => {
  // eslint-disable-next-line max-len
  const generateURL = encodeURI(`https://outlook.live.com/owa/?rru=addevent&startdt=${meetingInfo.startTime}&enddt=${meetingInfo.endTime}&subject=${meetingInfo.title}&to=${meetingInfo.participantsEmail}&location=NA&body=${meetingInfo.description}&path=/calendar/view/Month`);
  window.open(generateURL, '_blank');

};

export const icsDownload = async (meetingInfo: any, option?:any) => {
  let attendees: any = await attendee(meetingInfo.participants);
  var startDate = moment(meetingInfo.startTime);
  var endDate = moment(meetingInfo.endTime);
  const event = {
    start: [startDate.year(), startDate.month() + 1, startDate.date(), startDate.hours(), startDate.minutes()],
    end: [endDate.year(), endDate.month() + 1, endDate.date(), endDate.hours(), endDate.minutes()],
    title: meetingInfo.title,
    description: meetingInfo.altDescription,
    location: 'NA',
    url: meetingInfo.altDescription.join,
    status: 'CONFIRMED',
    busyStatus: 'BUSY',
    organizer: meetingInfo.organizer,
    attendees: attendees
  };
  await icsFile.createEvent(event, (error: any, value: any) => {
    if (error) {
      console.log(error);
      return;
    }
    if(!option){
      fileDownload(meetingInfo.title, meetingInfo.meetingId, value);
    } else if(option && option==="add") {
      icsOpen(meetingInfo.title, meetingInfo.meetingId, value)
    }
  });
};

const icsOpen = (title: string, meetingId: string, content: string) => {
  var element = document.createElement('a');
  const blob1 = new Blob([content],{"type":"text/calendar"});
  const file = new File([blob1], title+"-"+meetingId+".ics", {"type":"text/calendar"});
  var formData = new FormData();
  formData.append("doc",file);
let token:any = getCookie("ssoToken");
    const url: string = `${config().CHAT_RESTAPI_URL}/upload/files`;
    var authkey = {
      "Content-Type": "application/json",
      Authorization: token
    };
     axios
      .post(url,formData, { headers: authkey })
      .then((res:any) =>{
        if(res.data && res.data.files && Array.isArray(res.data.files) &&  res.data.files.length>0 && res.data.files[0]){
          const webURL = 'webcal://'+res.data.files[0]?.geturl;
          window.open(webURL.replace("https://",""));
        }
        
      })
      .catch((err:any)=>{
  });
  document.body.appendChild(element);
  element.click();
};

const attendee = async (participants: any) => {
  let text: Array<any> = await participants.map((data: any) => {
    return { name: data.name, email: data.email, rsvp: true, partstat: 'ACCEPTED', role: 'REQ-PARTICIPANT' };
  });
  return text;
};

const fileDownload = (title: string, meetingId: string, content: string) => {
  var element = document.createElement('a');
  element.setAttribute('href', 'data:text/calendar;charset=utf-8,' + encodeURI(content));
  element.setAttribute('download', `${title} - ${meetingId}.ics`);
  document.body.appendChild(element);
  element.click();
};

// const rRRule = (data:string) => {
//   let untilData:any = data.split("\n")[1].split(";")[1];
//   let rData:any = data.split("\n")[1].split(";")[0];
//   let dataArr:any = [ rData, untilData ];
//   return dataArr;
// };
export const RRuleTimeCal = (stamp: number, duration: number) => {
  let endDate: Date = new Date(stamp);
  endDate.setMinutes(endDate.getMinutes() + duration);
  return endDate.getTime();
};

export const convertRruleToText = (rrule:any) => {
  let rruleOptions: any = RRule.fromString(rrule);
  let rruleText: any = rruleOptions.toText();
  return rruleText;
}

// export const convertRruleToDates = (rrule:any) => {
//   let rruleOptions: any = RRule.fromString(rrule);
//   let rruleDates: any = rruleOptions.all();
//   return rruleDates;
// }